import { page } from '@updater/ulytics';
import { selectors } from '../../../../state';
import template from './moving-center-companies.html';
import './moving-center-companies.global.css';

class MovingCenterCompaniesController {
  constructor(updStore) {
    'ngInject';
    Object.assign(this, { updStore });
  }

  $onInit() {
    this.disconnect = this.updStore.connect(mapStateToThis)(this);

    this.updStore.dispatch(
      page('MC Companies', { Matches: this.matches.length })
    );
  }

  $onDestroy() {
    this.disconnect();
  }

  get headerTitle() {
    return this.hasMatches ? 'These movers are the best' : 'Aw shucks...';
  }

  get prefaceText() {
    return this.hasMatches
      ? `You're looking at the best options for moving companies. Would you rather `
      : `We couldn't find any movers in your neighborhood. Try a`;
  }

  get ctaText() {
    return `do-it-yourself move${this.hasMatches ? '?' : '.'}`;
  }
}

export const MovingCenterCompaniesComponent = {
  template,
  transclude: true,
  controller: MovingCenterCompaniesController,
  bindings: {
    moveId: '<',
  },
};

function mapStateToThis(state) {
  const moveId = selectors.current.move(state).id(state);
  const matches = selectors.movingCenter.matches(moveId, state);

  return {
    hasMatches: matches && matches.length > 0,
    matches,
    moveId,
  };
}
